export const getTranslatedText = (getTranslation, customerAccess) => {
  const translationMap = {
    view: getTranslation("coming_soon_label"),
    purchase: getTranslation("early_access_label"),
  };

  return translationMap[customerAccess] || "";
};
